import {Injectable} from '@angular/core';
import {Observable, shareReplay, Subject} from 'rxjs';
import {ShopInfoBean} from "../../bean/shop.info.bean";
import {EchUtils} from '../../ech-utils/ech-utils';
import {FormControl, FormGroup, NonNullableFormBuilder, Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ShopService{
  validateForm: FormGroup<{
    shopInfo: FormControl<any>;
  }>;
  shopInfoListObservable: Observable<Object>;
  loginObservable: Observable<Object>;
  shopInfoSubject = new Subject();

  constructor(private echUtils:EchUtils,private fb: NonNullableFormBuilder) {
    this.validateForm = this.fb.group({
      shopInfo: ['', [Validators.required]],
    });

    this.shopInfoListObservable = this.echUtils.postObservable("/api/manageWholeSaleShop/userShop/setCookie4ShopId")
      .pipe(shareReplay(1));
  }

  subscribe(callback: (shopInfoBean: ShopInfoBean) => void) {
    if(this.validateForm.controls.shopInfo.valid){
      callback(this.validateForm.controls.shopInfo.value);
      return;
    }
    let subscription = this.shopInfoSubject.subscribe((response: any) => {
      callback(this.validateForm.controls.shopInfo.value);
      subscription.unsubscribe();
    });
  }
}
